import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate, Navigate } from 'react-router-dom';
import Landingpage from './components/Landingpage';
import Header from './components/Header';
import Footer from './components/Footer';
import AboutUs from './components/AboutUs';
import ContactUs from './components/ContactUs';
import CofeeShop from './components/BusinessAreas/CofeeShop';
import Restaurentselfservice from './components/BusinessAreas/Restaurentselfservice';
import ChocolateDisplay from './components/BusinessAreas/ChocolateDisplay';
import ButcheryCharcuterie from './components/BusinessAreas/ButcheryCharcuterie';
import Supermarket from './components/BusinessAreas/Supermarket';
import ScrollToTop from './components/ScrollToTop';
import Bakerypastery from './components/BusinessAreas/Bakerypastery';
import Takeaway from './components/BusinessAreas/Takeaway';
import Icecream from './components/BusinessAreas/Icecream';
import Sushi from './components/BusinessAreas/Sushi';
import Fishseafood from './components/BusinessAreas/Fishseafood';
import Display from './components/ModelsPages/Display';
import Multideck from './components/ModelsPages/Multideck';
import Islands from './components/ModelsPages/Islands';
import Semivertical from './components/ModelsPages/Semivertical';
import Intelligent from './components/ModelsPages/Intelligent';
import CaseStudies from './components/CaseStudies';
import ProductDetails from './components/ModelsPages/ProductDetails';
import MultideckProductDetails from './components/ModelsPages/MultideckProductDetails';
import IslandsProductDetails from './components/ModelsPages/IslandsProductDetails';
import SemivertProductDetails from './components/ModelsPages/SemivertProductDetails';
import InteliProductDetails from './components/ModelsPages/InteliProductDetails';
import MainHomeModel from './components/ModelsPages/MainHomeModel';
import ProductDetail from './components/ModelsPages/ProductDetails';
import Moresolutions from './components/ModelsPages/Moresolutions';
import MoresolutionsDetailspage from './components/ModelsPages/MoresolutionsDetailspage';
import Vista from './components/Products/Vista';
import Eline from './components/Products/Eline';
import Kubo from './components/Products/Kubo';
import Daisy from './components/Products/Daisy';
import Minimal from './components/Products/Minimal';
import Scoop from './components/Products/Scoop';
import Iris from './components/Products/Iris';
import Columbs from './components/Products/Columbs';
import Pura from './components/Products/Pura';
import Pristage2 from './components/Products/Pristage2';
import Passionlux from './components/Products/Passionlux';
import Clickgo from './components/Products/Clickgo';
import Clickbuybye from './components/Products/Clickbuybye';
import Columbss from './components/Products/Columbss';
import Futura2 from './components/Products/Futura2';
import United from './components/Products/United';
import Expobz from './components/Products/Expobz';
import Futuroexpo from './components/Products/Futuroexpo';
import Futuraisland from './components/Products/Futuraisland';
import Urban from './components/Products/Urban';
import Vistagrabgo from './components/Products/Vistagrabgo';
import Fututocombi from './components/Products/Fututocombi';
import Victory from './components/Products/Victory';
import Frescocombi from './components/Products/Frescocombi';
import Daissy from './components/Products/Daissy';
import Futuro2 from './components/Products/Futuro2';
import Daissyice from './components/Products/Daissyice';
import Futurofish from './components/Products/Futurofish';
import Futuro22 from './components/Products/Futuro22';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
      {/* <Breadcrumbs/> */}
    </Router>
  );
}

function AppContent() {
  

  return (
    <>
    <Header />
      <Routes>
        <Route path="/" element={<Landingpage />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/casestudies" element={<CaseStudies />} />


        {/* Business Areas */}
        <Route path="/cofee" element={<CofeeShop />} />
        <Route path="/bakerypastry" element={<Bakerypastery />} />
        <Route path="/restaurent" element={<Restaurentselfservice />} />
        <Route path="/choclote" element={<ChocolateDisplay />} />

        <Route path="/butchery" element={<ButcheryCharcuterie />} />
        <Route path="/supermarket" element={<Supermarket />} />
        <Route path="/takeaway" element={<Takeaway />} />
        <Route path="/icecream" element={<Icecream />} />
        <Route path="/sushi" element={<Sushi />} />
        <Route path="/seafood" element={<Fishseafood />} />

 {/* Models */}
 <Route path="/mainhomemodel" element={<MainHomeModel />} />

 <Route path="/display" element={<Display />} />
 <Route path="/multideck" element={<Multideck />} />
 <Route path="/islands" element={<Islands />} />
 <Route path="/semiverticals" element={<Semivertical />} />
 <Route path="/intelligent" element={<Intelligent />} />
 <Route path="/moresolutions" element={<Moresolutions />} />



{/* products details */}
<Route path="/vista" element={<Vista />} />
<Route path="/e-line" element={<Eline />} />
<Route path="/kubo" element={<Kubo />} />
<Route path="/daisy-upper" element={<Daissy />} />
<Route path="/daisy-lower" element={<Daisy />} />
<Route path="/daisy-ice" element={<Daissyice />} />

<Route path="/minimal" element={<Minimal />} />
<Route path="/scoop" element={<Scoop />} />
<Route path="/iris" element={<Iris />} />
<Route path="/Columbus-lower" element={<Columbs />} />
<Route path="/pura" element={<Pura />} />
<Route path="/passionlux" element={<Passionlux />} />
<Route path="/Prestige2" element={<Pristage2 />} />

<Route path="/CLICK&COLLECT" element={<Clickgo />} />
<Route path="/UNITEDBUYBYE" element={<Clickbuybye />} />

<Route path="/COLUMBUS" element={<Columbss />} />

<Route path="/FUTURO-22" element={<Futuro22 />} />
<Route path="/Futuro-2" element={<Futura2 />} />
<Route path="/United" element={<United />} />

<Route path="/EXPOBZ" element={<Expobz />} />
<Route path="/FUTUROEXPO" element={<Futuroexpo />} />
<Route path="/FUTUROISLAND" element={<Futuraisland />} />

<Route path="/URBAN" element={<Urban />} />

<Route path="/vista-grab-and-go" element={<Vistagrabgo />} />
<Route path="/FuturoCombi-lower" element={<Fututocombi />} />
<Route path="/Victory" element={<Victory />} />
<Route path="/FrescoCombi-lower" element={<Frescocombi />} />
<Route path="/FUTURO2-upper" element={<Futuro2 />} />

<Route path="/FUTUROFISH" element={<Futurofish />} />


















 










{/* <Route path="/product/:name" element={<ProductDetail />} />
<Route path="/multideckproduct/:name" element={<MultideckProductDetails />} />
<Route path="/islandsproduct/:name" element={<IslandsProductDetails />} />
<Route path="/moresolutionsproduct/:name" element={<MoresolutionsDetailspage />} />
<Route path="/semiverticalsproduct/:name" element={<SemivertProductDetails />} />
<Route path="/intelligentproduct/:name" element={<InteliProductDetails />} /> */}



     
      </Routes>
       <Footer />
    </>
  );
}

export default App;

// import React, { useEffect, useState } from 'react';
// import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate, Navigate } from 'react-router-dom';
// import Landingpage from './components/Landingpage';
// import Header from './components/Header';
// import Footer from './components/Footer';
// import AboutUs from './components/AboutUs';
// import ContactUs from './components/ContactUs';
// import CofeeShop from './components/BusinessAreas/CofeeShop';
// import Restaurentselfservice from './components/BusinessAreas/Restaurentselfservice';
// import ChocolateDisplay from './components/BusinessAreas/ChocolateDisplay';
// import ButcheryCharcuterie from './components/BusinessAreas/ButcheryCharcuterie';
// import Supermarket from './components/BusinessAreas/Supermarket';
// import ScrollToTop from './components/ScrollToTop';
// import Bakerypastery from './components/BusinessAreas/Bakerypastery';
// import Takeaway from './components/BusinessAreas/Takeaway';
// import Icecream from './components/BusinessAreas/Icecream';
// import Sushi from './components/BusinessAreas/Sushi';
// import Fishseafood from './components/BusinessAreas/Fishseafood';
// import AdminDashboard from './components/AdminDashboard';
// import AdminLogin from './components/AdminLogin';
// import AdminRegister from './components/AdminRegister';
// import Adddisplaybanner from './components/Models/Adddisplaybanner';
// import DisplayUpdateDel from './components/Models/DisplayUpdateDel';
// import Display from './components/ModelsPages/Display';
// import Multideck from './components/ModelsPages/Multideck';
// import Islands from './components/ModelsPages/Islands';
// import Semivertical from './components/ModelsPages/Semivertical';
// import Intelligent from './components/ModelsPages/Intelligent';
// import CaseStudies from './components/CaseStudies';
// import ProductDetails from './components/ModelsPages/ProductDetails';
// import MultideckProductDetails from './components/ModelsPages/MultideckProductDetails';
// import IslandsProductDetails from './components/ModelsPages/IslandsProductDetails';
// import SemivertProductDetails from './components/ModelsPages/SemivertProductDetails';
// import InteliProductDetails from './components/ModelsPages/InteliProductDetails';
// import MainHomeModel from './components/ModelsPages/MainHomeModel';

// function App() {
//   return (
//     <Router>
//       <ScrollToTop />
//       <AppContent />
//       {/* <Breadcrumbs/> */}
//     </Router>
//   );
// }

// function AppContent() {
//   const [adminLoggedIn, setAdminLoggedIn] = useState(false);
//   const location = useLocation();
//   const navigate = useNavigate();

//   useEffect(() => {
//     const checkAuth = async () => {
//       const token = localStorage.getItem('usertoken');

//       if (!token) {
//         setAdminLoggedIn(false);
//         if (location.pathname.startsWith('/admin')) navigate('/adminlogin');
//         return;
//       }

//       try {
//         const res = await fetch(`${process.env.REACT_APP_REQUESTING_API}/validation`, {
//           method: 'GET',
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (res.ok) {
//           setAdminLoggedIn(true);
//           if (location.pathname === '/adminlogin') navigate('/admin/dashboard');
//         } else {
//           setAdminLoggedIn(false);
//           if (location.pathname.startsWith('/admin')) navigate('/adminlogin');
//         }
//       } catch (error) {
//         console.error('Error during validation:', error);
//         setAdminLoggedIn(false);
//         if (location.pathname.startsWith('/admin')) navigate('/adminlogin');
//       }
//     };

//     checkAuth();
//   }, [location.pathname, navigate]);

//   const isAdminRoute = location.pathname.startsWith('/admin');

//   return (
//     <>
//       {!isAdminRoute && <Header />}
//       <Routes>
//         <Route path="/" element={<Landingpage />} />
//         <Route path="/aboutus" element={<AboutUs />} />
//         <Route path="/contactus" element={<ContactUs />} />
//         <Route path="/casestudies" element={<CaseStudies />} />


//         {/* Business Areas */}
//         <Route path="/cofee" element={<CofeeShop />} />
//         <Route path="/bakerypastry" element={<Bakerypastery />} />
//         <Route path="/restaurent" element={<Restaurentselfservice />} />
//         <Route path="/choclote" element={<ChocolateDisplay />} />

//         <Route path="/butchery" element={<ButcheryCharcuterie />} />
//         <Route path="/supermarket" element={<Supermarket />} />
//         <Route path="/takeaway" element={<Takeaway />} />
//         <Route path="/icecream" element={<Icecream />} />
//         <Route path="/sushi" element={<Sushi />} />
//         <Route path="/seafood" element={<Fishseafood />} />

//  {/* Models */}
//  <Route path="/mainhomemodel" element={<MainHomeModel />} />


//  <Route path="/display" element={<Display />} />
//  <Route path="/multideck" element={<Multideck />} />
//  <Route path="/islands" element={<Islands />} />
//  <Route path="/semiverticals" element={<Semivertical />} />
//  <Route path="/intelligent" element={<Intelligent />} />


// {/* products details */}
// <Route path="/product/:id" element={<ProductDetails />} />
// <Route path="/multideck/:id" element={<MultideckProductDetails />} />
// <Route path="/islands/:id" element={<IslandsProductDetails />} />
// <Route path="/semiverticals/:id" element={<SemivertProductDetails />} />

// <Route path="/intelligent/:id" element={<InteliProductDetails />} />



//         {/* Admin Routes */}
//         <Route
//           path="/admin/dashboard/*"
//           element={adminLoggedIn ? <AdminDashboard /> : <Navigate to="/adminlogin" />}
//         />
//         <Route path="/adminlogin" element={<AdminLogin setAdminLoggedIn={setAdminLoggedIn} />} />
//         <Route path="/AdminDSGOregister" element={<AdminRegister />} />


//         {/* Admin Model Routes */}
//         <Route path="addproduct" element={<Adddisplaybanner />} />
//           <Route path="updatedeleteproduct" element={<DisplayUpdateDel />} />
//       </Routes>
//       {!isAdminRoute && <Footer />}
//     </>
//   );
// }

// export default App;


